import * as Room from '../services/room';
import * as Booking from '../services/booking';
import * as Auth from '../services/auth';
import * as Setting from '../services/setting';
import * as Upload from '../services/upload';
import * as History from '../services/history';
import * as Form from '../services/form';
import * as Review from '../services/review';
import * as News from '../services/news';
import * as Teacher from '../services/teacher';
import * as Employee from '../services/employee';
import * as Course from '../services/course';
import * as Manage from '../services/manage';
import * as Timetable from '../services/timetable';
import * as Claim from '../services/claim';
import * as Unavailable from '../services/unavailable';


export const RoomService = Room;
export const BookingService = Booking;
export const AuthService = Auth;
export const SettingService = Setting;
export const UploadService = Upload;
export const HistoryService = History;
export const FormService = Form;
export const ReviewService = Review;
export const NewsService = News;
export const TeacherService = Teacher;
export const CourseService = Course;
export const ManageService = Manage;
export const TimetableService = Timetable;
export const ClaimService = Claim;
export const EmployeeService = Employee;
export const UnavailableService = Unavailable;
